function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Pari-_x2F_rivitalo"
}, /*#__PURE__*/React.createElement("title", null, "VF_battery_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 116.3l-77.9-52.5-63.9 42.9L78 63.8 0 116.3v103.4h283.5V116.3zm-255.2 75v-60L78 98l49.5 33.4v60H28.3zm127.6 0v-60L205.6 98l49.5 33.4v60h-99.2z"
}))));